import { connect } from 'react-redux';

import adminPaymentGateways from '_store/_actions/adminPaymentGateways';

import PaymentGateways from './PaymentGateways';

const mapStateToProps = state => ({
  activeCompany: state.company.activeCompany,
  user: state.auth.user,
  isLoading: state.adminPaymentGateways.isLoading,
  paymentGateways: state.adminPaymentGateways.paymentGateways,
});

const mapDispatchToProps = {
  onCreatePaymentGateway: adminPaymentGateways.createAdminPaymentGateway,
  onUpdatePaymentGateway: adminPaymentGateways.updateAdminPaymentGateway,
  onDeletePaymentGateway: adminPaymentGateways.deleteAdminPaymentGateway,
  onFetchPaymentGateways: adminPaymentGateways.fetchAdminPaymentGateways,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentGateways);
